// Module
var code = `<div class="js-snapshot-container">

    <div class="labels">
        <div class="labels-column-first">
            <div class="label title"><!-- Пустая ячейка колонки --></div>
            <div class="label title">{{priceLabelText}}</div>
            <div class="label title">{{sizeLabelText}}</div>
            <div class="label title">{{changeLabelText}}</div>
            <div class="label title">{{highLabelText}}</div>
            <div class="label title">{{lowLabelText}}</div>
        </div>
        <div class="labels-column">
            <div class="label title">{{lastLabelText}}</div>
            <div class="label">{{Last}}</div>
            <div class="label">{{LastSize}}</div>
            <div class="label" style="{{ChangeStyle}}">{{Change}}</div>
            <div class="label">{{High}}</div>
            <div class="label">{{Low}}</div>
        </div>
        <div class="labels-column">
            <div class="label title">{{bidLabelText}}</div>
            <div class="label bid">{{Bid}}</div>
            <div class="label">{{BidSize}}</div>
            <div class="label title">{{changePercentLabelText}}</div>
            <div class="label title">{{volumeLabelText}}</div>
            <div class="label"><!-- Пустая ячейка колонки --></div>
        </div>
        <div class="labels-column">
            <div class="label title">{{askLabelText}}</div>
            <div class="label ask">{{Ask}}</div>
            <div class="label">{{AskSize}}</div>
            <div class="label {{ChangeStyle}}">{{ChangePercent}}</div>
            <div class="label">{{Volume}}</div>
            <div class="label"><!-- Пустая ячейка колонки --></div>
        </div>
    </div>

    <div class="btns">
        <terceraButton terceraButtonStyle="js-button-ok" text="{{getSnapshotBtnText}}" on-btnClick="getSnapshotBtnClick" enabled="{{!getSnapshotBtnDisabled}}" tooltip="{{getSnapshotBtnTooltip}}"/>
        <terceraButton terceraButtonStyle="js-button-gray25" text="{{closeBtnText}}" on-btnClick="closeBtnClick" />
    </div>
</div>`;
// Exports
export default code;